import {Box, HBox} from '@buncha/components/core/view';
import {CustomText, H6Text} from '@buncha/components/core/text';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {ChevronRightIcon} from 'native-base';
import {CustomImage} from '@buncha/components/core/Image';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {intercom} from '@buncha/config/analytics/intercom';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useGetLocale} from '@buncha/localization/hooks';

const AdjacentOOSBanner = () => {
  const theme = useColorThemeType();
  const font = useFontTheme();
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const ADJOOS_BANNER_CAROUSEL_ID = useAppSelector(
    gState => gState.onboarding.constants,
  )?.ADJOOS_BANNER_CAROUSEL_ID;

  const handleCarouselOpen = useCallback(() => {
    if (ADJOOS_BANNER_CAROUSEL_ID)
      intercom.showCarousel(ADJOOS_BANNER_CAROUSEL_ID);
  }, [ADJOOS_BANNER_CAROUSEL_ID]);

  return (
    <Touchable onPress={handleCarouselOpen}>
      <HBox
        style={[
          styles.mainContainer,
          {
            backgroundColor: theme?.background?.blue?.[200],
            borderColor: theme?.text?.blue?.[100],
          },
        ]}>
        <CustomImage
          style={styles.multiStoreIcon}
          resizeMode="contain"
          source={require('@buncha/resource/images/MultiStore.png')}
        />
        <Box style={styles.textContainer}>
          <H6Text
            style={[
              styles.textAlignLeft,
              {fontFamily: font[600].normal, color: theme?.text?.blue?.[300]},
            ]}>
            {body?.itemUnavailable}
          </H6Text>
          <CustomText
            style={[
              styles.textAlignLeft,
              {fontFamily: font[400].normal, color: theme?.text?.blue?.[300]},
            ]}>
            {body?.shareThisItem}
          </CustomText>
        </Box>
        <ChevronRightIcon
          style={[
            styles.icon,
            {
              color: theme?.text?.blue[300],
            },
          ]}
        />
      </HBox>
    </Touchable>
  );
};

export default React.memo(AdjacentOOSBanner);

const styles = StyleSheet.create({
  textAlignLeft: {
    textAlign: 'left',
  },
  textContainer: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flex: 1,
  },
  mainContainer: {
    borderWidth: 1,
    padding: 10,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 10,
    borderRadius: 5,
  },
  icon: {alignSelf: 'center'},
  multiStoreIcon: {
    height: 36,
    width: 36,
    alignSelf: 'center',
    marginTop: 2,
  },
});
